import { BENEFICIARY_STATUS_BADGE_COLORS } from 'modules/beneficiaries/constants/constants';
import { snakeToTitleCase } from 'utils/utils';

export const getBeneficiaryStatusBadgeColorScheme = (status) => BENEFICIARY_STATUS_BADGE_COLORS[status] ?? 'gray';

export const formatBeneficiaryStatus = (status) => (status ? snakeToTitleCase(status) : '-');

export const readFileAsBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result ?? '';
      const [, base64] = String(result).split(',');

      if (!base64) {
        reject(new Error('Could not read the selected file'));

        return;
      }

      resolve(base64);
    };
    reader.onerror = () => reject(new Error('Could not read the selected file'));
    reader.readAsDataURL(file);
  });
